"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitBox = exports.StyledContactInfoBox = exports.StyledContactBox = exports.ContactBox = exports.StyledFormBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

var _MediaQueries = _interopRequireDefault(require("../../../MediaQueries"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledFormBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledFormBox",
  componentId: "sc-7gqa3v-0"
})(["max-width:calc(100vw - 32px);width:100%;", " form{#name-label{color:", ";}#email-label{color:", ";}#subject-label{color:", ";}#message-label{color:", ";}.form-error{input{border:none;border-bottom:1px solid ", ";}label{color:", " !important;}}}form > div{max-width:calc(100vw - 32px);", " textarea:focus{border-bottom:1px solid #D7D7D7;}}label{font-size:14px;line-height:20px;background:transparent;color:", ";font-family:", ";> span{font-family:", ";}}input{background-color:transparent;border-top:none;border-left:none;border-right:none;border-bottom:", ";border-radius:", ";height:", ";font-size:", ";padding:12px 0;flex:0 0 auto;color:", ";width:", ";outline:none;font-family:", ";.form-error &{border:1px solid ", ";}&:focus{border-bottom:", ";}}input::placeholder{color:", ";opacity:1;}textarea{background-color:transparent;border-top:none;border-left:none;border-right:none;border-bottom:", ";border-radius:", ";flex:0 0 auto;padding:12px 0;height:", ";color:", ";font-family:", ";outline:none;", " .form-error &{border:1px solid ", ";}&:focus{outline:none;}}textarea::placeholder{color:", ";opacity:1;}button{width:198px;height:48px;display:flex;align-items:center;justify-content:center;background:", ";font-family:", ";font-style:normal;font-weight:bold;font-size:16px;line-height:24px;letter-spacing:0.05em;text-transform:uppercase;color:", ";cursor:pointer;border:1px solid ", ";&:hover{border:1px solid ", ";background:", ";color:", ";}}", ""], _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    max-width: 656px;\n  "]))), function (props) {
  return props.isNameInputFocus ? props.theme.portfolioForeground1 : props.theme.portfolioForeground2;
}, function (props) {
  return props.isEmailInputFocus ? props.theme.portfolioForeground1 : props.theme.portfolioForeground2;
}, function (props) {
  return props.isSubjectInputFocus ? props.theme.portfolioForeground1 : props.theme.portfolioForeground2;
}, function (props) {
  return props.isMessageTextareaFocus ? props.theme.portfolioForeground1 : props.theme.portfolioForeground2;
}, function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return props.theme.negativeRed;
}, _MediaQueries["default"].minWidth.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      max-width: 656px;\n    "]))), function (props) {
  return props.theme.portfolioForeground2;
}, function (props) {
  return props.theme.portfolioFontFamily;
}, function (props) {
  return props.theme.portfolioFontFamily;
}, function (props) {
  return "1px solid ".concat(props.theme.portfolioBorder);
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return props.theme.formInputHeight;
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return !props.fullWidth ? 'initial' : '100%';
}, function (props) {
  return props.theme.portfolioFontFamily;
}, function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return "1px solid ".concat(props.theme.portfolioForeground1);
}, function (props) {
  return props.theme.portfolioForeground2;
}, function (props) {
  return "1px solid ".concat(props.theme.portfolioBorder);
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return props.height ? "".concat(props.height, "px") : '132px';
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioFontFamily;
}, function (props) {
  return props.height && (0, _styledComponents.css)(["resize:none;"]);
}, function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return props.theme.portfolioForeground2;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioFontFamily;
}, function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.newtonStyles && (0, _styledComponents.css)(["", " ", ";"], props.isTabletPortrait && "\n      padding-right: ".concat(props.theme.spacingSm, ";\n    "), props.isDesktopSmall && "\n      margin-top: 84px; \n      padding-right: 48px;\n      max-width: 656px;\n    ");
});
exports.StyledFormBox = StyledFormBox;
var ContactBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ContactBox",
  componentId: "sc-7gqa3v-1"
})(["box-sizing:border-box;background:", ";"], function (props) {
  return props.theme.portfolioBackground1;
});
exports.ContactBox = ContactBox;
var StyledContactBox = (0, _styledComponents["default"])(ContactBox).withConfig({
  displayName: "Elements__StyledContactBox",
  componentId: "sc-7gqa3v-2"
})(["flex-direction:column;align-items:center;", ";"], function (props) {
  return props.newtonStyles && (0, _styledComponents.css)(["padding-top:76px;", " ", ""], props.isTabletPortrait && "\n      align-items: flex-start;\n      padding-top: unset;\n    ", props.isDesktopSmall && "\n      flex-direction: row;\n      padding-top: unset;\n    ");
});
exports.StyledContactBox = StyledContactBox;
var StyledContactInfoBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledContactInfoBox",
  componentId: "sc-7gqa3v-3"
})(["padding:0 ", ";text-align:center;max-width:656px;", ""], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.newtonStyles && (0, _styledComponents.css)(["padding:0;", ";", ";", ";", ";"], props.isTabletPortrait && "\n    justify-content: unset;\n    align-items: unset;\n\n    h1, p {\n      text-align: left;\n    }\n  ", props.isDesktopSmall && "\n    max-width: 392px;\n    width: 100%;\n    margin-right: 32px;\n  ", props.isDesktopMedium && "\n    max-width: 494px;\n    margin-right: 74px;\n  ", props.isDesktopLarge && "\n    margin-right: 194px;\n  ");
});
exports.StyledContactInfoBox = StyledContactInfoBox;
var SubmitBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__SubmitBox",
  componentId: "sc-7gqa3v-4"
})(["justify-content:flex-start;button{border-radius:0;&:hover{background:", ";border-color:", ";}}", ""], function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.centerSendEmailBtn && "\n    justify-content: center;\n  ";
});
exports.SubmitBox = SubmitBox;